/** @jsxImportSource @emotion/react */
import React, { ReactElement } from 'react'
import * as classes from './styles'

export type FooterWrapperProps = {
  children: ReactElement | ReactElement[]
  className?: string
}

export const FooterWrapper = ({ children, className }: FooterWrapperProps) => (
  <div className={className} css={classes.footerWrapper}>
    {children}
  </div>
)
